export const FieldTypes = Object.freeze({
  document:  'DOCUMENT',
  signature: 'SIGNATURE'
})
